export default __webpack_public_path__ + "static/media/ClutchesImg.f8ccbbdf.jpg";